import React from 'react';
import { FlatList, View, Image, Text, TouchableOpacity, Linking } from 'react-native';
import classes from '../../../../styles/globalClasses';
import gs from '../../../../styles/globalStyles';
import ls from './HorizontalScrollScreen.styles';
import { checkColor } from '@app/utils';
import { ThemedText, ThemedView } from '@app/theme';
const blog1 = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/blog1.png';
const blog1Url =
  'https://www.livemint.com/money/personal-finance/dont-redeem-take-a-loan-against-mutual-funds-11692032217610.html';
const blog2Url =
  'https://medium.com/@ranjank9503/unlocking-opportunities-leveraging-loan-against-mutual-funds-e40dcb511270';
const blog3Url =
  'https://medium.com/@ranjank9503/choosing-loan-against-mutual-funds-over-personal-loans-a-comprehensive-guide-737ae740f4cb';

const VOLT =
  'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/volt_timer.png';
const GREEN_BOOK_ICON =
  'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Green_book.png';
const WATCH_VIDEO_ICON =
  'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/watch_video_image.png';

const llsVideoUrl = 'https://www.youtube.com/watch?v=lK7KuMzRm8U';

const llaBannerUrl =
  'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/lla_banner.png';

const data = [
  {
    key: '1',
    text: 'See why Labour Law Advisor recommends loan against MF',
    iconUrl: WATCH_VIDEO_ICON,
    imageUrl: llaBannerUrl,
    url: llsVideoUrl,
    subText: 'Watch now',
  },
  {
    key: '2',
    text: 'Don’t redeem, take a loan against MF (via mint)',
    iconUrl: GREEN_BOOK_ICON,
    imageUrl: blog1,
    url: blog1Url,
    subText: 'Read now',
  },
  {
    key: '2',
    text: 'Why you should take a loan against you Mutual Funds',
    iconUrl: GREEN_BOOK_ICON,
    imageUrl: VOLT,
    url: blog2Url,
    subText: 'Read now',
  },
  {
    key: '3',
    text: 'Borrow smartly: LAMF vs. Personal Loans',
    iconUrl: GREEN_BOOK_ICON,
    imageUrl: VOLT,
    url: blog3Url,
    subText: 'Read now',
  },
];
const HorizontalScrollScreen = () => {
  const renderItem = ({ item }) => (
    <ThemedView>
      <ThemedView style={ls.iconContainer}>
        <Image
          source={{ uri: item.iconUrl }}
          style={{
            width: 42,
            height: 42,
          }}
        />
      </ThemedView>
      <ThemedView 
        backgroundColor='bg-fill-primary' 
        width={208}
        borderRadius='sm'
        mr='xl'
        >
        <ThemedView>
          <Image source={{ uri: item.imageUrl }} style={ls.image} />
        </ThemedView>
        <ThemedView style={ls.textContainer}>
          <ThemedText variant='b2s' color='text-primary'
            numberOfLines={2}
            ellipsizeMode="tail">
            {item.text}
          </ThemedText>
        </ThemedView>
        <ThemedView
          style={ls.urlContainer}
          nativeID={`txt_landingScreen_readNow${item.key}`}>
          <TouchableOpacity onPress={() => Linking.openURL(item.url)}>
            <ThemedText variant='b2s' color='text-action-primary'
              numberOfLines={2}
              ellipsizeMode="tail">
              {item.subText}
            </ThemedText>
          </TouchableOpacity>
        </ThemedView>
      </ThemedView>
    </ThemedView>
  );

  return (
    <ThemedView style={ls.flatListContainer}>
      <FlatList
        horizontal
        data={data}
        renderItem={renderItem}
        keyExtractor={item => item.key}
        showsHorizontalScrollIndicator={false}
      />
    </ThemedView>
  );
};

export default HorizontalScrollScreen;
